// extracted by mini-css-extract-plugin
module.exports = {"accordion-item":"S_c1","accordionItem":"S_c1","open":"S_c2","icon":"S_bj","toogler":"S_c3","title":"S_bH","content":"S_L","content-body":"S_c4","contentBody":"S_c4","text":"S_cB"};